gsap.registerPlugin(ScrollTrigger);

let bgChangeTriggers = []; // массив только для этих триггеров
const bgChangeMobileMediaQuery = '(max-width: 640px)';
let bgChangeMediaQuery;

const getBgChangeStart = (element) => {
  const defaultStart = element.dataset.secBgChangeStart || 'top 50%';

  if (!bgChangeMediaQuery?.matches) {
    return defaultStart;
  }

  return element.dataset.secBgChangeMobileStart || defaultStart;
};

window.bgChangeAnimation = function bgChangeAnimation() {
  const body = document.querySelector('body');
  const bodyBg = document.querySelector('.body-bg');
  const elements = Array.from(document.querySelectorAll('[data-sec-bg-change]'));
  let currentBgChangeElement = null;
  let currentBgChangeTheme = null;

  // убиваем старые триггеры перед созданием новых
  bgChangeTriggers.forEach((t) => t.kill());
  bgChangeTriggers = [];

  const isOnlyDark = !document.querySelectorAll('[data-sec-bg-change-light]');

  const isElementInViewport = (element) => {
    if (!element) {
      return false;
    }

    const rect = element.getBoundingClientRect();
    return rect.top < window.innerHeight && rect.bottom > 0;
  };

  const isBeforeCustomEnd = (candidate, endTrigger) => {
    const end = candidate.dataset.secBgChangeEnd;

    if (!end || !endTrigger) {
      return isElementInViewport(candidate);
    }

    const [triggerEdge, viewportPosition] = end.split(/\s+/);
    const viewportRatio = Number.parseFloat(viewportPosition) / 100;

    if (
      !['top', 'bottom'].includes(triggerEdge) ||
      !viewportPosition?.endsWith('%') ||
      !Number.isFinite(viewportRatio)
    ) {
      return isElementInViewport(candidate);
    }

    const endTriggerRect = endTrigger.getBoundingClientRect();

    return endTriggerRect[triggerEdge] > window.innerHeight * viewportRatio;
  };

  const getVisibleCustomEndOwner = (element) =>
    elements.find((candidate) => {
      const endTriggerSelector = candidate.dataset.secBgChangeEndTrigger;
      const endTrigger = endTriggerSelector
        ? document.querySelector(endTriggerSelector)
        : null;

      if (!endTrigger) {
        return false;
      }

      return (
        endTrigger === element && isBeforeCustomEnd(candidate, endTrigger)
      );
    });

  const hasCustomEndOwner = (element) =>
    elements.some((candidate) => {
      const endTriggerSelector = candidate.dataset.secBgChangeEndTrigger;

      return (
        endTriggerSelector &&
        document.querySelector(endTriggerSelector) === element
      );
    });

  const getBackgroundTheme = (element) => {
    const isTextDigitalHandoff = element.classList.contains(
      'is-text-digital-handoff'
    );
    const isLight =
      element.hasAttribute('data-sec-bg-change-light') &&
      !isTextDigitalHandoff;
    const isDark =
      element.hasAttribute('data-sec-bg-change-dark') || isTextDigitalHandoff;

    if (isLight && !isOnlyDark) {
      return 'light';
    }

    return isDark ? 'dark' : null;
  };

  const applyBackgroundTheme = (element, theme) => {
    if (theme === 'light') {
      bodyBg.classList.remove('is-bg-dark');
      bodyBg.classList.add('is-bg-light');
      body.classList.remove('is-bg-dark');
      body.classList.add('is-bg-light');

      document.documentElement.style.setProperty(
        '--mf-cursor-bg-actual',
        `${getComputedStyle(element).getPropertyValue('--cl-black').trim()}`
      );
      return;
    }

    if (theme === 'dark') {
      bodyBg.classList.remove('is-bg-light');
      bodyBg.classList.add('is-bg-dark');
      body.classList.remove('is-bg-light');
      body.classList.add('is-bg-dark');

      document.documentElement.style.setProperty(
        '--mf-cursor-bg-actual',
        `${getComputedStyle(element).getPropertyValue('--cl-white').trim()}`
      );
    }
  };

  const activateElement = (sourceElement, options = {}) => {
    const { ignoreCustomEndOwner = false, force = false } = options;
    const element = ignoreCustomEndOwner
      ? sourceElement
      : getVisibleCustomEndOwner(sourceElement) || sourceElement;
    const theme = getBackgroundTheme(element);

    if (
      !force &&
      currentBgChangeElement === element &&
      currentBgChangeTheme === theme
    ) {
      return;
    }

    elements.forEach((el) => {
      el.classList.remove('is-bg-changes', 'is-next-bg-changes');
    });

    element.classList.add('is-bg-changes');
    if (element.previousElementSibling) {
      element.previousElementSibling.classList.add('is-next-bg-changes');
    }

    applyBackgroundTheme(element, theme);

    if (element.classList.contains('latest-works-sec-wr')) {
      bodyBg.classList.remove('is-worked-full-video-bg');
      body.classList.remove('is-worked-full-video-bg');
    }

    currentBgChangeElement = element;
    currentBgChangeTheme = theme;
  };

  window.syncBgChangeTheme = (sourceElement) => {
    if (!elements.includes(sourceElement)) {
      return;
    }

    activateElement(sourceElement, {
      ignoreCustomEndOwner: true,
      force: true,
    });
  };

  elements.forEach((element) => {
    const start = getBgChangeStart(element);
    const end = element.dataset.secBgChangeEnd || 'bottom 50%';
    const endTriggerSelector = element.dataset.secBgChangeEndTrigger;
    const endTrigger = endTriggerSelector
      ? document.querySelector(endTriggerSelector)
      : null;

    const next = element.nextElementSibling;

    if (next) {
      const currentIsDark = element.hasAttribute('data-sec-bg-change-dark');
      const currentIsLight = element.hasAttribute('data-sec-bg-change-light');
      const nextIsDark = next.hasAttribute('data-sec-bg-change-dark');
      const nextIsLight = next.hasAttribute('data-sec-bg-change-light');

      if ((currentIsDark && nextIsDark) || (currentIsLight && nextIsLight)) {
        element.classList.add('is-next-same-bg');
      }
    }

    const triggerOptions = {
      trigger: element,
      start,
      end,
      onToggle: (self) => {
        if (self.isActive) {
          activateElement(element);
          return;
        }

        if (self.direction < 0) {
          const customEndOwner = getVisibleCustomEndOwner(element);

          if (customEndOwner) {
            activateElement(customEndOwner, { ignoreCustomEndOwner: true });
          }
        }
      },
    };

    if (hasCustomEndOwner(element)) {
      triggerOptions.onUpdate = (self) => {
        if (self.isActive) {
          activateElement(element);
        }
      };
    }

    if (endTrigger) {
      triggerOptions.endTrigger = endTrigger;
    }

    const trigger = ScrollTrigger.create(triggerOptions);

    bgChangeTriggers.push(trigger);
  });

  ScrollTrigger.refresh();
};

window.reinitBgChangeAnimation = function reinitBgChangeAnimation() {
  bgChangeAnimation();
};

const initBgChangeMediaQuery = () => {
  if (bgChangeMediaQuery || typeof window.matchMedia !== 'function') {
    return;
  }

  bgChangeMediaQuery = window.matchMedia(bgChangeMobileMediaQuery);
  const reinitBackgroundChange = () => window.bgChangeAnimation?.();

  if (typeof bgChangeMediaQuery.addEventListener === 'function') {
    bgChangeMediaQuery.addEventListener('change', reinitBackgroundChange);
    return;
  }

  bgChangeMediaQuery.addListener(reinitBackgroundChange);
};

initBgChangeMediaQuery();

if (!document.querySelector('.bold-loader-new')) {
  bgChangeAnimation();
}
